import { BaseResponseAttributes } from "../attributes/base-attributes";
import { RestApiResponse } from "./RestApi";
import BaseService from "./BaseService";
import {
  BusinessWithdrawPercentAttributes,
  BusinessWithdrawPercentSearchAttributes,
} from "../attributes/business-withdraw-percent-attributes";
import BusinessWithdrawPercent from "../models/BusinessWithdrawPercent";
import { FaqAttributes } from "../attributes/faq-attributes";
import Faq from "../models/Faq";

export class FaqService extends BaseService {
  static async getPaginate(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return FaqService.getApiClient().get(`admin/faqs`);
  }

  static async getAll(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return FaqService.getPublicApiClient().get(`faqs/faqs-list`);
  }

  static async addFaq(
    data: FaqAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = "admin/faqs/add";

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return FaqService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async updateFaq(
    faqId: number,
    data: Faq
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = `admin/faqs/${faqId}/update`;

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return FaqService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async searchFaqs(
    data: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = `admin/faqs/search`;

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return FaqService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async searchFaqsPublic(
    data: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = `faqs/search`;

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return FaqService.getPublicApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default FaqService;
